export enum TripTableStatusEnum {
    PENDING = 'PENDING',
    CURRENT = 'CURRENT',
    FINISH = 'FINISH',
    CANCELED = 'CANCELED',
    CLOSED = 'CLOSED',
    UNKNOWN = 'UNKNOWN',
}
